import appConfig from './config.js';
import { msalConfig, loginRequest, protectedResources } from './auth.js';

// Validate all required environment variables in one place
const requiredVars = [
  'VITE_API_URL',
  'VITE_AZURE_B2C_CLIENT_ID',
  'VITE_AZURE_B2C_AUTHORITY',
  'VITE_AZURE_B2C_KNOWN_AUTHORITIES',
  'VITE_AZURE_B2C_REDIRECT_URI',
  'VITE_AZURE_B2C_SCOPES'
];

for (const varName of requiredVars) {
  if (!import.meta.env[varName]) {
    throw new Error(`Missing ${varName} in environment variables. Please check your .env file.`);
  }
}

// Log configuration in development
if (appConfig.isDevelopment) {
  console.log('Frontend Configuration:', {
    apiUrl: appConfig.apiUrl,
    isDevelopment: appConfig.isDevelopment,
    monitoring: appConfig.monitoring,
    auth: {
      authority: msalConfig.auth.authority,
      redirectUri: msalConfig.auth.redirectUri,
      scopes: loginRequest.scopes
    }
  });
}

export {
  appConfig as config,
  msalConfig,
  loginRequest,
  protectedResources
};

// Re-export commonly used values
export const {
  apiUrl,
  API_BASE_URL,
  isDevelopment,
  monitoring
} = appConfig;
